var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A545E",
    fillRule: "evenodd",
    d: "M11.574 3.133a.75.75 0 0 1 .852 0l6.385 4.403A2.75 2.75 0 0 1 20 9.8v8.45A2.75 2.75 0 0 1 17.25 21H6.75A2.75 2.75 0 0 1 4 18.25V9.8c0-.904.444-1.75 1.189-2.264zM10.5 19.5h3v-4.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25zm4.5 0v-4.75A1.75 1.75 0 0 0 13.25 13h-2.5A1.75 1.75 0 0 0 9 14.75v4.75H6.75c-.69 0-1.25-.56-1.25-1.25V9.8c0-.41.202-.796.54-1.029L12 4.661l5.96 4.11c.338.233.54.618.54 1.03v8.449c0 .69-.56 1.25-1.25 1.25z",
    clipRule: "evenodd"
  })));
};
export default SvgHome;